import { defineMessages } from 'react-intl'

import { EBusinessCustomerStatus } from 'features/BusinessCustomer/types'

export const businessCustomerStatusMessages = defineMessages({
  [EBusinessCustomerStatus.ACTIVE]: {
    id: 'dictionary.active',
    defaultMessage: 'Active'
  },
  [EBusinessCustomerStatus.INACTIVE]: {
    id: 'dictionary.inactive',
    defaultMessage: 'Inactive'
  }
})
